import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { InfoIcon } from 'Components/CustomIcons/InfoIcon'
import Button from 'NewVersion/components/UI/Buttons/Button'
import { CrossIcon } from 'NewVersion/icons/CrossIcon'
import 'NewVersion/styles/ArtistHasRepresentantDialog.scss'
import { useTranslation } from 'react-i18next'

/**
 * ArtistHasRepresentantDialog - Dialog shown when an artist has a representant assigned
 * Only shown in the "Gestio" flow, not in "Presentar"
 *
 * @param {object} artist - The artist object with representant
 * @param {function} onContinueAsRepresentant - Callback to continue as representant
 * @param {function} onClose - Callback to close the dialog
 */
export const ArtistHasRepresentantDialog = ({ artist, onContinueAsRepresentant, onClose }) => {
  const { t } = useTranslation()

  // Extract representant name from path or object
  const getRepresentantName = () => {
    if (artist?.title_representant) {
      return artist.title_representant
    }
    if (artist?.representant) {
      // Path format: /year/rep_id
      const parts = artist.representant.split('/')
      return parts[parts.length - 1]
    }
    return t('unknown')
  }

  return (
    <Dialog open={true} className="artist-has-rep-dialog" onClose={onClose}>
      <div className="cross-icon" onClick={onClose}>
        <CrossIcon fill={'black'} width="22" height="22" />
      </div>

      <div className="artist-has-rep-dialog__content">
        <DialogTitle>
          <div className="artist-has-rep-dialog__title-row">
            <InfoIcon width={32} height={32} fill="#D60D1A" />
            <span>{t('artist_has_representant_title')}</span>
          </div>
        </DialogTitle>

        <DialogContent>
          <p className="artist-has-rep-dialog__message">
            {t('artist_has_representant_message', {
              artistName: artist?.title || t('unknown'),
            })}
          </p>

          <p className="artist-has-rep-dialog__rep-name">{getRepresentantName()}</p>
        </DialogContent>

        <DialogActions>
          <Button onClick={onContinueAsRepresentant} dataTest="btnContinueAsRepresentant">
            {t('continue_as_representant')}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  )
}

export default ArtistHasRepresentantDialog
